import { render } from "./FormLogin.vue?vue&type=template&id=978d475c&scoped=true&ts=true"
import script from "./FormLogin.vue?vue&type=script&lang=ts"
export * from "./FormLogin.vue?vue&type=script&lang=ts"

import "./FormLogin.vue?vue&type=style&index=0&id=978d475c&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-978d475c"]])

export default __exports__